<template>
  <div class="login-main">
    <nav-bar></nav-bar>
    <section class="orders-status-start">
      <div
        class="review-container review-main text-capitalize position-relative"
      >
        <lottie-animation
          ref="anim"
          :animationData="require('@/assets/animation.json')"
          class="animationCls"
          v-if="isAnimation"
        />
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="chowman-pay-details plr15 d-flex justify-space-between">
              <h4 class="text-left">{{ $t("Chowman Pay") }}</h4>
              <div class="full-btn">
                <router-link
                  :to="{ name: 'chowman-pay-history' }"
                  class="back-btn btn"
                  >History</router-link
                >
              </div>
            </div>
            <div
              class="orders-tab-main reserve-orders plr15 mt-4"
              v-if="Object.keys(displayRestaurant).length > 0"
            >
              <div class="chowmna-pay d-flex align-items-start">
                <div class="img-cls resimg-squre">
                  <img
                    v-if="displayRestaurant.icon_image"
                    :src="displayRestaurant.icon_image"
                    @error="$event.target.src = noImge"
                  />
                </div>
                <div class="respay-name">
                  <p class="resname mb-0">{{ displayRestaurant.name }}</p>
                  <span v-if="displayRestaurant.default_pay_cashback > 0"
                    >{{ parseFloat(displayRestaurant.default_pay_cashback) }}%
                    Chowman pay cashback</span
                  >
                </div>
                <div class="btn-chomn">
                  <a
                    href="javascript:void(0)"
                    @click="allRestaurants()"
                    class="menu-link mt-2"
                    v-if="restaurants.length > 1"
                    >Change</a
                  >
                </div>
              </div>
            </div>
            <div class="pay-chowmn mt-4" v-if="restaurants.length > 0">
              <span
                v-html="$auth.setting && $auth.setting.currency"
                class="currency"
              ></span>
              <input
                class="form-control mb-0 h50"
                type="number"
                onKeyPress="if(this.value.length==8) return false;"
                placeholder="0.0"
                id="amount"
                name="amount"
                v-model="amount"
                autofocus
                style="resize: horizontal; width: 200px"
              />
            </div>

            <div class="nostr-img-cls" v-else>
              <img src="@/assets/images/no_store.png" />
              <div class="no-txt-fnd">{{ noStoreMsg }}</div>
            </div>

            <div class="billing-data border-0 mt-2" v-if="amount > 0">
              <ul>
                <li class="d-flex justify-content-between paidline">
                  {{ $t("To be paid") }}
                  <div>
                    <span
                      v-html="$auth.setting.currency"
                      class="currency"
                    ></span>
                    <span>{{ parseFloat(totalAmountPay).toFixed(2) }}</span>
                  </div>
                </li>
                <li class="d-flex justify-content-between">
                  {{ $t("Bill Amount") }}
                  <div>
                    <span
                      v-html="$auth.setting.currency"
                      class="currency"
                    ></span>
                    <span>{{ parseFloat(amount) }}</span>
                  </div>
                </li>
                <li
                  class="d-flex justify-content-between promo-discount"
                  v-if="payCashback"
                >
                  <p>
                    {{ $t("Chowman pay cashback") }}
                    <i
                      v-b-tooltip.hover.right.nofade.v-danger="
                        'This amount will be credited to you Chowman Wallet.....'
                      "
                      class="fa fa-info-circle"
                      aria-hidden="true"
                    ></i>
                  </p>
                  <div>
                    <span
                      v-html="$auth.setting.currency"
                      class="currency"
                    ></span>
                    <span>{{ payCashback.toFixed(2) }}</span>
                  </div>
                </li>
                <li
                  class="d-flex justify-content-between discount"
                  v-if="promoDiscount"
                >
                  {{ $t("Discount") }}
                  <div>
                    -<span
                      ><span
                        v-html="$auth.setting.currency"
                        class="currency"
                      ></span
                      >{{ parseFloat(promoDiscount).toFixed(2) }}</span
                    >
                  </div>
                </li>
                <li
                  class="d-flex justify-content-between promo-discount"
                  v-if="promoCashback"
                >
                  <p>
                    {{ $t("Cashback") }}
                    <i
                      v-b-tooltip.hover.right.nofade.v-danger="
                        'This amount will be credited to your Chowman Wallet upon successful payment of your order.'
                      "
                      class="fa fa-info-circle"
                      aria-hidden="true"
                    ></i>
                  </p>
                  <span
                    ><span
                      v-html="$auth.setting.currency"
                      class="currency"
                    ></span
                    >{{ parseFloat(promoCashback).toFixed(2) }}</span
                  >
                </li>
              </ul>
              <div class="review-boxs mt-4 promocode-sec">
                <h6 class="mb-2">{{ $t("promo code") }}</h6>
                <a
                  href="javascript:void(0)"
                  @click="promocodeModal"
                  class="lnk offer-btn"
                  >{{ $t("View Offers") }}</a
                >
                <input
                  class="form-control mb-0 h50 line-input"
                  type="text"
                  :placeholder="$t('Enter Promo code')"
                  aria-label="promocode"
                  v-model="promocode"
                  ref="promocode"
                />
                <a
                  href="javascript:void(0)"
                  @click="applyPromocode(promocode)"
                  class="lnk"
                  v-if="!isPromocodeApply"
                  >{{ $t("Apply") }}</a
                >
                <a
                  href="javascript:void(0)"
                  @click="removePromocode()"
                  class="lnk nw-close"
                  v-if="isPromocodeApply"
                  >{{ $t("Remove") }}</a
                >
              </div>
              <p v-if="promoError" class="promoerr">{{ promoError }}</p>
              <div class="delivery-address mt-5">
                <div class="full-btn">
                  <button @click="checkOrder()" :disabled="isDisabled">
                    {{ $t("Pay now") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-------chowmnpay New Modal------->
    <div
      class="modal fade chowmnpay-modal"
      id="payModal"
      tabindex="-1"
      aria-labelledby="payModallabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content location-modal">
          <div class="modal-header">
            <h4 class="modal-title" id="filterLabel"></h4>
            <a data-dismiss="modal" class="lnk" @click="isPayModalOpen = false">
              <!-- {{$t('Close')}} -->
              <svg
                fill="#000000"
                width="25px"
                height="25px"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z"
                  ></path>
                </g>
              </svg>
            </a>
          </div>
          <div
            class="modal-body"
            v-if="isPayModalOpen && restaurants.length > 0"
          >
            <div
              class="chowmna-pay d-flex align-items-start"
              v-for="(rest, i) in restaurants"
              :key="i"
              @click="selectRestaurant(rest)"
            >
              <div class="img-cls resimg-squre">
                <img
                  v-if="rest.icon_image"
                  :src="rest.icon_image"
                  @error="$event.target.src = noImge"
                />
              </div>
              <div class="respay-name">
                <p class="resname mb-0">{{ rest.name }}</p>
                <span v-if="rest.default_pay_cashback > 0"
                  >{{ parseFloat(rest.default_pay_cashback) }}% Chowman pay
                  cashback</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-------chowmnpay New Modal------->
    <!--------All Promocode Modal start---------->
    <div
      class="modal fade order-placed"
      id="promocodeModal"
      tabindex="-1"
      aria-labelledby="promocodeModallabel"
      aria-hidden="true"
      ref="promocodeModalRef"
      style="z-index: 9999"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="filterLabel">{{ $t("Promocode") }}</h4>
            <a data-dismiss="modal" class="lnk">
              <!-- {{ $t("Close") }} -->
              <svg
                fill="#000000"
                width="25px"
                height="25px"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z"
                  ></path>
                </g>
              </svg>
            </a>
          </div>
          <div class="modal-body text-center" v-if="promoCodes.length > 0">
            <div
              class="order-item d-flex align-items-center justify-content-between"
              v-for="(offers, index) in this.promoCodes"
              :key="index"
            >
              <div class="d-flex align-items-start">
                <div class="smallimg-squre">
                  <img :src="offers.coupon_image" />
                </div>
                <div
                  class="order-data ml-3 d-flex align-items-start justify-content-between w-100"
                >
                  <div class="orders-status-main">
                    <h6 class="mb-0">{{ offers.coupon_name }}</h6>
                    <p
                      class="mt-1 prom-desc"
                      :id="'shortdec' + offers.id"
                      style="display: block"
                    >
                      {{ offers.description.substring(0, 54) }}
                      <a
                        v-if="
                          offers.description && offers.description.length > 54
                        "
                        href="javascript:void(0)"
                        @click="readMore(offers.id)"
                        class="readmore"
                        >...more</a
                      >
                    </p>
                    <p
                      :id="'moredesc' + offers.id"
                      style="display: none"
                      class="prom-desc"
                    >
                      {{ offers.description }}
                      <a
                        href="javascript:void(0)"
                        @click="readMore(offers.id)"
                        class="readless"
                        >less</a
                      >
                    </p>
                    <div class="promocode mt-2">
                      <p>
                        {{ $t("Code") }}:
                        <span class="m-promocode">{{
                          offers.coupon_code
                        }}</span>
                      </p>
                      <div class="copn-cl">
                        <a
                          class="cart-btn"
                          @click="applyPromocode(offers.coupon_code)"
                          >{{ $t("Apply") }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="modal-body text-center">
            <p>{{ $t("No Offers Available") }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--------All Promocode Modal End---------->
    <Footer></Footer>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import LottieAnimation from "lottie-web-vue";
import NavBar from "@/components/NavBar.vue";
import Footer from "../components/Footer.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import noImge from "@/assets/images/place_holder.png";

export default {
  components: {
    NavBar,
    Footer,
    "skeleton-loader-vue": VueSkeletonLoader,
    LottieAnimation,
  },
  data() {
    return {
      restaurants: [],
      latitude: "",
      longitude: "",
      displayRestaurant: {},
      isPayModalOpen: false,
      amount: "",
      defaultPayCashback: 0,
      restaurant_id: "",
      payCashback: 0,
      totalAmountPay: 0,
      promoError: "",
      promocode: "",
      isPromocodeApply: false,
      promoCodes: [],
      isAnimation: false,
      promoDiscount: 0,
      isDisabled: true,
      promoCashback: 0,
      noImge,
      noStoreMsg: "",
    };
  },

  mounted() {
    if (
      this.$auth.user &&
      this.$auth.setting.chowman_pay &&
      this.$auth.setting.chowman_pay == "active"
    ) {
      if (this.$auth.restaurant_id && this.$auth.restaurant_id != 0) {
        this.restaurant_id = this.$auth.restaurant_id;
      }
      this.nearByRestaurant();
    } else {
      this.$router.push({ name: "Home" });
    }
  },

  watch: {
    amount: function () {
      if (this.amount < 1) {
        this.amount = "";
      }
      this.promocode = "";
      this.isPromocodeApply = false;
      this.promoDiscount = 0;
      this.promoCashback = 0;
      this.displayCharge();
    },
  },

  methods: {
    ...mapActions("restaurant", ["getNearbyResturantData"]),
    ...mapActions("promocode", ["getPromoCodesData", "getRedeemPromocodeData"]),
    ...mapMutations("order", [
      "chowmanPayPlaceOrder",
      "clearPlaceOrderData",
      "chowmanPayGiftPlaceOrder",
    ]),

    nearByRestaurant() {
      this.getNearbyResturantData({
        latitude: parseFloat(localStorage.getItem("latitude")),
        longitude: parseFloat(localStorage.getItem("longitude")),
        restaurant_id: this.restaurant_id ? this.restaurant_id : "",
      }).then((data) => {
        if (data.code == 200) {
          this.restaurants = data.Result;
          this.noStoreMsg = data.msg;
          if (data.Result.length > 0) {
            this.displayRestaurant = data.Result[0];
            this.defaultPayCashback = data.Result[0].default_pay_cashback;
            this.restaurant_id = data.Result[0].restaurant_id;
          }
        }
      });
    },

    allRestaurants() {
      this.isPayModalOpen = true;
      $("#payModal").modal("show");
    },

    selectRestaurant(value) {
      this.amount = "";
      this.displayRestaurant = value;
      this.defaultPayCashback = parseFloat(value.default_pay_cashback);
      this.restaurant_id = value.restaurant_id;
      $("#payModal").modal("hide");
    },

    displayCharge() {
      if (this.defaultPayCashback > 0) {
        this.payCashback =
          (parseFloat(this.amount) * this.defaultPayCashback) / 100;
      }
      this.totalAmountPay =
        parseFloat(this.amount).toFixed(2) -
        parseFloat(this.promoDiscount).toFixed(2);
      if (this.totalAmountPay > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },

    //Promocode modal
    promocodeModal() {
      this.getPromoCodesData({
        user_id: this.$auth.user.user_id,
        restaurant_id: this.restaurant_id,
        is_langauge: this.$store.state.lang.locale,
        vendor_id: this.$auth.getVendorId(),
      }).then((data) => {
        if (data.code == 200) {
          this.promoCodes = data.Result;
        }
        $("#promocodeModal").modal("show");
      });
    },

    //Apply Promocode For function
    applyPromocode(code) {
      let currency = "";
      if (
        document.getElementById("currency") &&
        document.getElementById("currency").childNodes[0]
      ) {
        currency =
          document.getElementById("currency").childNodes[0].textContent;
      }
      this.promoCashback = "";
      this.promoDiscount = "";
      this.promocode = code;
      this.$refs.promocode.value = code;
      if (this.$refs.promocode.value) {
        this.getRedeemPromocodeData({
          vendor_id: this.$auth.getVendorId(),
          is_langauge: this.$store.state.lang.locale,
          original_price: this.totalAmountPay,
          promo_code: this.$refs.promocode.value,
          restaurant_id: this.restaurant_id,
        }).then((data) => {
          if (data.code == 200) {
            let result = data.Result;
            if (result.minimum_order_amount <= this.totalAmountPay) {
              this.isAnimation = true;
              this.coupon_id = result.id;

              this.promoCodeType = result.is_flat_discount;
              this.promoDiscount = result?.calulation?.promocode_discount || 0;
              this.promoCashback = result?.calulation?.promocode_cashback || 0;

              // let ttlDiscount = this.totalAmountPay;
              // if(this.totalAmountPay > result.flat_discount){
              // ttlDiscount   =  result.flat_discount;
              // }
              // this.promoCashback = (result.flat_discount * result.cashback) / 100;
              // this.promoDiscount = ttlDiscount - this.promoCashback;

              if (result.is_flat_discount == 1) {
                //Falt Discount
                // let flatDiscount = result.flat_discount;
                // this.promoCodeType = 1;
                // if (flatDiscount > this.totalAmountPay) {
                //     this.promoDiscount = this.totalAmountPay;
                // } else {
                //     this.promoDiscount = flatDiscount;
                // }
                this.isPromocodeApply = true;
                this.$swal({
                  icon: "success",
                  showCloseButton: true,
                  showConfirmButton: false,
                  html:
                    '<span class="text-black currency">You have got ' +
                    this.$auth.setting.currency +
                    parseFloat(this.promoDiscount).toFixed(2) +
                    ' Discount. </span> <br> <span class="pm-txt">' +
                    this.$auth.setting.promocode_text +
                    "</span>",
                }).then((result) => {
                  this.isAnimation = false;
                });
              } else if (result.is_flat_discount == 0) {
                //Percenage Discount
                // this.promoCodeType = 0;
                // let discountAmount = ((this.totalAmountPay / 100) * result.discount_percentage).toFixed(2);
                // this.promoDiscount = Math.min.apply(Math, [discountAmount, result.maximum_discount_amount]);
                this.isPromocodeApply = true;
                this.$swal({
                  showCloseButton: true,
                  showConfirmButton: false,
                  icon: "success",
                  html:
                    '<span class="text-black currency">You have got ' +
                    this.$auth.setting.currency +
                    parseFloat(this.promoDiscount).toFixed(2) +
                    ' Discount. </span><br><span class="pm-txt">' +
                    this.$auth.setting.promocode_text +
                    "</span>",
                }).then((result) => {
                  this.isAnimation = false;
                });
              } else if (result.is_flat_discount == 2) {
                //Flat cashback
                // this.promoCodeType = 2;
                // let discount =((this.totalAmountPay / 100) * result.cashback).toFixed(2);
                // if (discount > result.maximum_discount_amount) {
                //     discount = result.maximum_discount_amount;
                // }
                // this.promoCashback = discount;
                // this.isPromocodeApply = true;
                this.$swal({
                  icon: "success",
                  showCloseButton: true,
                  showConfirmButton: false,
                  html:
                    '<span class="text-black currency">You have got ' +
                    this.$auth.setting.currency +
                    parseFloat(this.promoCashback).toFixed(2) +
                    this.$t(" cashback") +
                    '.</span> <br><span class="pm-txt">' +
                    this.$auth.setting.promocode_text +
                    "</span>",
                }).then((result) => {
                  this.isAnimation = false;
                });
              } else if (result.is_flat_discount == 3) {
                //Percenage Discount
                // this.promoCodeType = 3;
                // let discountAmount = (this.totalAmountPay  * result.discount_percentage) / 100;
                // let cashbackAmount = (this.totalAmountPay * result.cashback) / 100;
                // if((cashbackAmount+discountAmount) > result.maximum_discount_amount){
                //     let totalPer = (result.cashback+result.discount_percentage)
                //     this.promoCashback =(result.maximum_discount_amount * result.cashback) / totalPer;
                //     this.promoDiscount =(result.maximum_discount_amount * result.discount_percentage) / totalPer;
                // }else{
                //     this.promoCashback = cashbackAmount;
                //     this.promoDiscount = discountAmount;
                // }
                this.isPromocodeApply = true;
                this.$swal({
                  showCloseButton: true,
                  showConfirmButton: false,
                  icon: "success",
                  html:
                    '<span class="text-black currency">You have got ' +
                    this.$auth.setting.currency +
                    parseFloat(this.promoDiscount).toFixed(2) +
                    this.$t(" Discount") +
                    " and " +
                    '<span class="currency">' +
                    this.$auth.setting.currency +
                    "</span>" +
                    parseFloat(this.promoCashback).toFixed(2) +
                    " as cashback in Chowman Wallet." +
                    '</span> <br><span class="pm-txt">' +
                    this.$auth.setting.promocode_text +
                    "</span>",
                }).then((result) => {
                  this.isAnimation = false;
                });
              } else if (result.is_flat_discount == 4) {
                //Cashback With Percentage
                // this.promoCodeType = 4;
                // let ttlDiscount = this.totalAmountPay;
                // if(this.totalAmountPay > result.flat_discount){
                // ttlDiscount   =  result.flat_discount;
                // }
                // this.promoCashback = (result.flat_discount * result.cashback) / 100;
                // this.promoDiscount = ttlDiscount - this.promoCashback;
                // this.isPromocodeApply = true;
                this.$swal({
                  showCloseButton: true,
                  showConfirmButton: false,
                  icon: "success",
                  html:
                    '<span class="text-black currency">You have got ' +
                    this.$auth.setting.currency +
                    "</span>" +
                    parseFloat(this.promoDiscount).toFixed(2) +
                    " Discount and " +
                    ' <span class="currency">' +
                    currency +
                    "</span>" +
                    parseFloat(this.promoCashback).toFixed(2) +
                    "cashback in Chowman Wallet." +
                    '</span> <br><span class="pm-txt">' +
                    this.$auth.setting.promocode_text +
                    "</span>",
                }).then((result) => {
                  this.isAnimation = false;
                });
              }
               else if (result.is_flat_discount == 8) {
                //Cashback With Percentage
                // this.promoCodeType = 4;
                // let ttlDiscount = this.totalAmountPay;
                // if(this.totalAmountPay > result.flat_discount){
                // ttlDiscount   =  result.flat_discount;
                // }
                // this.promoCashback = (result.flat_discount * result.cashback) / 100;
                // this.promoDiscount = ttlDiscount - this.promoCashback;
                // this.isPromocodeApply = true;
                this.$swal({
                  showCloseButton: true,
                  showConfirmButton: false,
                  icon: "success",
                  html:
                    '<span class="text-black currency">You have got ' +
                    this.$auth.setting.currency +
                    "</span>" +
                    parseFloat(this.promoDiscount).toFixed(2) +
                    " Discount and " +
                    ' <span class="currency">' +
                    currency +
                    "</span>" +
                    parseFloat(this.promoCashback).toFixed(2) +
                    "cashback in Chowman Wallet." +
                    '</span> <br><span class="pm-txt">' +
                    this.$auth.setting.promocode_text +
                    "</span>",
                }).then((result) => {
                  this.isAnimation = false;
                });
              }
              this.displayCharge();
            } else {
              this.$swal({
                html:
                  "Sorry, the minimum chowman pay amount is <span v-html=" +
                  $auth.setting.currency +
                  ' class="currency"></span>' +
                  result.minimum_order_amount +
                  " for this coupon",
              });
            }
          } else if (data.code == 101) {
            this.promoError = data.msg;
            setTimeout(() => (this.promoError = false), 3000);
          }
        });
      } else {
        this.promoError = this.$t("Please Enter Promocode");
        setTimeout(() => (this.promoError = false), 3000);
      }
      this.isAnimation = false;
      $("#promocodeModal").modal("hide");
    },

    //Remove Apply Code
    removePromocode() {
      this.promocode = "";
      this.isPromocodeApply = false;
      this.promoDiscount = 0;
      this.promoCashback = 0;
      this.displayCharge();
    },

    checkOrder() {
      if (parseFloat(this.totalAmountPay).toFixed(2) >= 1) {
        let chowmanPayplaceOrderParameter = {
          user_id: this.$auth.user.user_id,
          restaurant_id: this.restaurant_id,
          amount: this.amount,
          promocode_amount: parseFloat(this.promoDiscount),
          promo_code: this.promocode,
          cashback_price: this.promoCashback,
          total_amount: parseFloat(this.totalAmountPay).toFixed(2),
          promo_code_id :this.coupon_id
        };
        this.$store.commit(
          "order/chowmanPayPlaceOrder",
          chowmanPayplaceOrderParameter
        );
        this.$store.commit("order/chowmanPayGiftPlaceOrder", {});
        this.$store.commit("order/clearPlaceOrderData");
        this.$router.push({ name: "payment" });
      } else {
        this.$swal({
          title: "Chowman",
          html:
            '<span class="text-black currency">To be paid must be atleast ' +
            this.$auth.setting.currency +
            "</span>1",
        });
      }
    },

    readMore(value) {
      $("#moredesc" + value).toggle(400);
      $("#shortdec" + value).toggle(400);
    },
  },
};
</script>
<style scoped>
li.d-flex.justify-content-between.paidline {
  font-size: 20px;
  font-weight: 600;
}

.full-btn button,
.full-btn button:hover {
  background: #e93e33;
  border: none;
}
button.btn.btn-primary.disabled,
.prcc-cls-blr,
.prcc-cls,
.prcc-cls:hover,
.prcc-cls-blr:hover {
  background: #e93e33;
  border: none;
}
.billing-data .delivery-address {
  border-top: 0 !important;
}

.chowmna-pay .btn-chomn {
  padding-left: 22%;
}
</style>
